define([
  "marionette",
  "messaging/messenger",
  "./template/apiResponseSelectorTemplate.html",
], function (Marionette, Messenger, ApiResponseSelectorTemplate) {
  const ApiResponseSelectorView = {};

  ApiResponseSelectorView.apiResponseSelectorView = Marionette.CompositeView.extend({
    template: ApiResponseSelectorTemplate,
    itemViewContainer: ".jsonChildren",
    tagName: "span",
    events: {
      "click .responseTarget": function () {
        Messenger.vent.trigger("element:selected", this.model);
        return false;
      },
      "click .delete-var-mapping": function () {
        Messenger.vent.trigger("element:selected"); //deselect any open variables
        Messenger.vent.trigger("variable:unlinked", this.model.get("conversationVariableId"));
        this.model.set("conversationVariableId", 0);
        this.render();
      },
    },
    modelEvents: {
      "change:showEditMenu": "render",
    },
    className: function () {
      //mark the last element in a collection with a special class so we can format accordingly
      if (this.model.collection) {
        const collectionSize = this.model.collection.length;
        if (this.model.collection.at(collectionSize - 1) === this.model) {
          return "last-element";
        }
      }
    },
    initialize: function () {
      this.collection = this.model.get("collection");
    },
    onRender: function () {
      this.$el.i18n();
      //set up source function to get the conversation variables for the typeahead data
      const _this = this;
      //get only variables not in the response already
      const variables = Messenger.reqres.request("unused:action:variables");
      const sourceFunction = function (_query, process) {
        const variableArr = [];
        //get the variable names and build an array for the typeahead to process
        variables.forEach(function (convVariable) {
          variableArr.push(convVariable.get("name"));
        });
        process(variableArr);
      };

      this.$el.find("input.variable-input").typeahead({
        source: sourceFunction,
        updater: function (item) {
          const variableId = variables.findWhere({ name: item }).id;
          const currentVariable = _this.model.get("conversationVariableId");
          if (currentVariable > 0) {
            Messenger.vent.trigger("variable:unlinked", currentVariable);
          }
          _this.model.set("conversationVariableId", variableId);
          _this.model.set("showEditMenu", false);
          Messenger.vent.trigger("variable:linked", _this.model.path, variableId);
        },
      });
      this.$el.find("input.variable-input").trigger("focus");
    },
  });

  return ApiResponseSelectorView;
});
